module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Yoga International","short_name":"Yoga International","start_url":"/","background_color":"#f3732a","theme_color":"#f3732a","display":"minimal-ui","icon":"src/images/YI-Logo_1080x1080.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"e328a6b842dda5489922621f33ecfaf8"},
    },{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://yogainternational.com/"},
    },{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"wAVk8cG7cEYAFMCF65RREEh5m2cUMJqs","devKey":"wAVk8cG7cEYAFMCF65RREEh5m2cUMJqs","delayLoad":true,"delayLoadTime":1000},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
